import { connect } from 'react-redux'
import { UpdateMediaTypeForm as Component } from './UpdateMediaTypeForm'

export const UpdateMediaTypeForm = connect()(Component)
